/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Available_ExtrasInputs */

const en_admin_external_booking_edit_available_extras = /** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Extras`)
};

const de_admin_external_booking_edit_available_extras = /** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Extras`)
};

const es_admin_external_booking_edit_available_extras = /** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras disponibles`)
};

const fr_admin_external_booking_edit_available_extras = /** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras disponibles`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */
const it_admin_external_booking_edit_available_extras = en_admin_external_booking_edit_available_extras;

/** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_available_extras = en_admin_external_booking_edit_available_extras;

/** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */
const pl_admin_external_booking_edit_available_extras = en_admin_external_booking_edit_available_extras;

/** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */
const hu_admin_external_booking_edit_available_extras = en_admin_external_booking_edit_available_extras;

/** @type {(inputs: Admin_External_Booking_Edit_Available_ExtrasInputs) => LocalizedString} */
const ro_admin_external_booking_edit_available_extras = en_admin_external_booking_edit_available_extras;

/**
* | output |
* | --- |
* | "Available Extras" |
*
* @param {Admin_External_Booking_Edit_Available_ExtrasInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_available_extras = /** @type {((inputs?: Admin_External_Booking_Edit_Available_ExtrasInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Available_ExtrasInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_available_extras(inputs)
	if (locale === "de") return de_admin_external_booking_edit_available_extras(inputs)
	if (locale === "es") return es_admin_external_booking_edit_available_extras(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_available_extras(inputs)
	if (locale === "it") return it_admin_external_booking_edit_available_extras(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_available_extras(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_available_extras(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_available_extras(inputs)
	return ro_admin_external_booking_edit_available_extras(inputs)
});
export { admin_external_booking_edit_available_extras as "admin.external_booking_edit.available_extras" }